import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 20a1 1 0 0 0 1-1V6c0-.297-.132-.578-.36-.77l-6-5a1.005 1.005 0 0 0-1.28 0L10 2.198 7.64.23a1.005 1.005 0 0 0-1.28 0l-6 5C.13 5.423 0 5.704 0 6v13a1 1 0 0 0 1 1h18zM8 18v-2h10v2H8zm-6 0v-2h4v2H2zM7 2.302L8.438 3.5l-2.08 1.73A1.018 1.018 0 0 0 6 6v8H2V6.47L7 2.3zm6 0l5 4.167V14H8V6.47l5-4.17zM13 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2z"
});

var SvgCollectionsMajorMonotone = function SvgCollectionsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgCollectionsMajorMonotone as S };
